(function(angular) {
    'use strict';
    var app = angular.module('enervee.account');

    /*
    AccountService is responsible for making account page api calls and model level calculations
    */

    app.factory('AccountService', [
        '$q',
        'AccountAuthService',
        'GetFetchService',
        'UtilService',
        'UserApiConsumerService',
        function(
            $q,
            AccountAuthService,
            GetFetchService,
            UtilService,
            UserApiConsumerService
        ) {
            var _pub = {};

            /**
             * Every time the user's auth changes, we want to forcibly update the details of the
             * stored user profile to be either `null` (if the user isn't logged in) or to be
             * actually updated.
             */
            AccountAuthService.onEveryAuthChange('update_user_profile', function () {
                var forceUpdate = true;
                if (!AccountAuthService.isLoggedInResponse.is_authenticated) {
                    GetFetchService.update('user-profile', null);
                } else {
                    _pub.getLoggedInUserProfile(forceUpdate);
                }
            });

            /**
             * Creates the initials based on the given accountInfo json which should contain first_name and last_name
             * key values
             *
             * @param accountInfo
             * @returns {string}
             */
            _pub.getInitials = function(accountInfo) {
                /**
                 * Returns the capitalized first letter of the given string
                 *
                 * @param string
                 * @returns {string}
                 * @private
                 */
                var _getInitial = function(string) {
                    return string.charAt(0).toUpperCase();
                };

                if (accountInfo) {
                    return _getInitial(accountInfo.first_name) + _getInitial(accountInfo.last_name);
                }
            };

            /**
             * Gets the logged in user profile info
             * @param {Boolean} [force=false]
             * @returns {Promise}
             */
            _pub.getLoggedInUserProfile = function (force) {
                return AccountAuthService.checkIfUserLoggedIn().then(function (response) {
                    if (response.is_authenticated) {
                        var urlOptions = {
                            url: 'api/1.0/user-profile/',
                            requestingService: UserApiConsumerService.request
                        };
                        return GetFetchService.get('user-profile', urlOptions, {
                            force: force,
                        });
                    }
                    return $q.resolve(null);
                });
            };

            /**
             * Helper function to determine if a category is active per site.
             * @param sectionName
             * @returns {boolean}
             */
            _pub.isAccountSectionActive = function (sectionName) {
                var accountSections = UtilService.getSiteSetting('active_account_sections', []);
                return accountSections.indexOf(sectionName) !== -1;
            };


            /**
             * Helper function to determine if user's email is verified.
             * @param {Boolean} [force=false]
             * @returns {Promise}
             */
            _pub.isUserEmailVerified = function (force) {
                return _pub.getLoggedInUserProfile(force).then(function (userProfile) {
                    return userProfile && userProfile.activated;
                });
            };

            return _pub;
        }
    ]);

})(angular);